module.exports = __webpack_public_path__ + "img/plus__mobile.0865d05c.svg";